import { desktopTutorial } from '@ro-sources/tutorials/desktop';
import { menuTutorial } from '@ro-sources/tutorials/menu';
import { spTutorial } from '@ro-sources/tutorials/sp';
import { estofexTutorial } from '@ro-sources/tutorials/estofex';
import { radarTutorial } from '@ro-sources/tutorials/radar';
import { lightningsTutorial } from '@ro-sources/tutorials/lightnings';
import { mapTutorial } from '@ro-sources/tutorials/map';
import { synopTutorial } from '@ro-sources/tutorials/synop';
import { visibilityTutorial } from '@ro-sources/tutorials/visibility';
import { tooltipTutorial } from '@ro-sources/tutorials/tooltip';
import { orderTutorial } from '@ro-sources/tutorials/order';

export const tutorials = {
  desktop: {
    steps: () => desktopTutorial('toMenuTutorial', 'Menu'),
    actionNext: '/menu',
    buttonId: 'toMenuTutorial',
    nextTutorialLevel: 2,
    index: 1,
    action: '/',
    name: 'Pulpit'
  },
  menu: {
    steps: () => menuTutorial('toSpTutorial', 'Skypredict'),
    actionNext: '/ustawienia/skypredict',
    nextTutorialLevel: 3,
    buttonId: 'toSpTutorial',
    index: 2,
    action: '/menu',
    name: 'Menu'
  },
  sp: {
    steps: () => spTutorial('toEstofexTutorial', 'Estofex'),
    actionNext: '/ustawienia/estofex',
    nextTutorialLevel: 4,
    buttonId: 'toEstofexTutorial',
    index: 3,
    action: '/ustawienia/skypredict',
    name: 'Skypredict'
  },
  estofex: {
    steps: () => estofexTutorial('toRadarTutorial', 'Radar'),
    actionNext: '/ustawienia/radar',
    nextTutorialLevel: 5,
    buttonId: 'toRadarTutorial',
    index: 4,
    action: '/ustawienia/estofex',
    name: 'Estofex'
  },
  radar: {
    steps: () => radarTutorial('toLightningsTutorial', 'Detektor'),
    actionNext: '/ustawienia/detektor-wyladowan',
    nextTutorialLevel: 6,
    buttonId: 'toLightningsTutorial',
    index: 5,
    action: '/ustawienia/radar',
    name: 'Radar'
  },
  lightnings: {
    steps: () => lightningsTutorial('toMapTutorial', 'Mapa'),
    actionNext: '/ustawienia/mapa',
    nextTutorialLevel: 7,
    buttonId: 'toMapTutorial',
    index: 6,
    action: '/ustawienia/detektor-wyladowan',
    name: 'Detektor'
  },
  map: {
    steps: () => mapTutorial('toSynopTutorial', 'Stacje synoptyczne'),
    actionNext: '/ustawienia/stacje-synoptyczne',
    nextTutorialLevel: 8,
    buttonId: 'toSynopTutorial',
    index: 7,
    action: '/ustawienia/mapa',
    name: 'Mapa'
  },
  synop: {
    steps: () => synopTutorial('toVisTutorial', 'Widoczność elementów'),
    actionNext: '/ustawienia/widocznosc-warstw',
    nextTutorialLevel: 9,
    buttonId: 'toVisTutorial',
    index: 8,
    action: '/ustawienia/stacje-synoptyczne',
    name: 'Stacje synoptyczne'
  },
  visibility: {
    steps: () => visibilityTutorial('toOrderTutorial', 'Kolejność warstw'),
    actionNext: '/ustawienia/kolejnosc-warstw',
    nextTutorialLevel: 10,
    buttonId: 'toOrderTutorial',
    index: 9,
    action: '/ustawienia/widocznosc-warstw',
    name: 'Widoczność elementów'
  },
  order: {
    steps: () => orderTutorial('toTooltipTutorial', 'Idź do serca RO'),
    actionNext: false,
    nextTutorialLevel: 11,
    buttonId: 'toTooltipTutorial',
    index: 10,
    action: '/ustawienia/kolejnosc-warstw',
    name: 'Kolejność warstw'
  },
  tooltip: {
    steps: () => tooltipTutorial('toEndOfTutorial', 'Zakończ tutorial'),
    actionNext: '/',
    nextTutorialLevel: 12,
    buttonId: 'toEndOfTutorial',
    index: 11,
    action: '/',
    name: 'Serce RO'
  }
};

export const tutorialExampleLocation = {
  label: 'Warszawa, województwo mazowieckie, Polska',
  hdms: '52° 13′ 55″ N 21° 00′ 25″ E',
  transformed: [2338458.097213566, 6842169.357607041],
  original: [21.0067265, 52.2319237],
  url: '21.0067265%7C52.2319237%7C6'
};
